export const TIMER_MODE__BLACK = 'b';
export const TIMER_MODE__WHITE = 'w';
export const TIMER_MODE__SPLIT = 'st';
export const TIMER_MODE__SPIRAL = 'sl';

export const TIMER_MODES = {
  TIMER_MODE__BLACK: 'b',
  TIMER_MODE__WHITE: 'w',
  TIMER_MODE__SPLIT: 'st',
  TIMER_MODE__SPIRAL: 'sl',
};
